module.exports = __webpack_public_path__ + "static/media/BoxPlotQ4_5.f00a3b05.svg";